<template>
  <div class="SlideList">
    <title-name :name="label"></title-name>
    <div class="list">
      <div class="item" v-for="(item, index) in List" :key="index" @click="gotoDetails(item.jobinnerid)">
        <div class="card">
          <p class="name">{{item.jobname}}</p>
          <p class="yearmoney">{{item.salarytext}}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- 侧边栏链接 -->
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import TitleName from '../components/TitleName'
export default {
  name: 'SlideList',
  props: ['List', 'label'],
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    gotoDetails (jobid) {
      const {href} = this.$router.resolve({
        name: "JobInfo",
        query: {jobid: jobid}
      })
      window.open(href, '_blank')
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
    TitleName
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.SlideList {
  float: right;
  margin-top: 20px;
  padding-top: 20px;
  width: 300px;
  background: #fff;
  .TitleName {
    padding: 0 20px;
    margin-bottom: 20px;
  }
  .list {
    .item {
     
      padding: 0 20px;
      font-size: 14px;
      cursor: pointer;
      .card {
        height: 42px;
        line-height: 42px;
        border-bottom: dashed 1px #E5E5E5;
      }

      &:hover {
        background: #F8F8F8;
      }

      &:last-child .card {
        border-bottom: none;
      }
      p.name {
        float: left;
        max-width: 154px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p.yearmoney {
        float: right;
        color: #FF7F04;
      }
    }
  }
}
</style>